import { Routes, Route, useSearchParams, useParams, Navigate } from "react-router";

import Index from './index';
import BlindKaizoRaces from './blindKaizoRaces/blindKaizoRaces';

function RacesHome() {
	const [searchParams] = useSearchParams();
	const raceType = searchParams.get('raceType');
	if (raceType === 'blindKaizo' || raceType === 'mysteryMonday') {
		return <BlindKaizoRaces />;
	}
	return <Index />;
}

export default function Races(){
	return <div className='pageContainer'>
		<Routes>
			<Route
				index
				element={<RacesHome />}
			/>
		</Routes>
	</div>
}